import React from 'react';
import { connect } from 'react-redux';
import { addProduct, reduceProduct } from '../../store/actions/shopCartActions';
import ProductCart from '../../components/CpProductCard/CpProductCard';
import CpSearchBar from '../../components/CpSearchBar';
import send from '../../util/request';
import classnames from 'classnames';
import { Button, Pagination } from 'antd';
import { planListAddProduct } from '../../store/actions/planListActions';
import { queryString } from '../../util/qs';
import './home.less';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      searchValue: '',
      searchType: '1',
      checkedCategoryId: '',
      checkedSubCategoryId: '',
      checkedThirdCategoryId: '',
      checkedFourthCategoryId: '',
      categoryList: [],
      subCategoryList: [],
      thirdCategoryList: [],
      fourthCategoryList: [],
      productList: [],
      currentPage: 1,
      pageSize: 50,
      productNum: 0,
      isOpen: false,
      isSubOpen: false,
      isThirdOpen: false,
      isFourthOpen: false
    };
  }
  async componentDidMount() {
    const { search = '', type = '1' } = this.props.match.params;
    const isSearch = !!search;
    const params = new URLSearchParams(this.props.location.search);
    const item_name = params.get('item_name'), subItem_name = params.get('subItem_name');
    await this.getCategory();
    const { categoryList = [] } = this.state;
    const item = categoryList.find(item => item.name === item_name) || { id: '', };
    const { id: checkedCategoryId, child: subCategoryList = [] } = item;
    const { id: checkedSubCategoryId } = subCategoryList.find(item => item.name === subItem_name) || { id: '' };
    this.setState({ isSearch, searchValue: search, checkedCategoryId, checkedSubCategoryId, subCategoryList, searchType: String(type) }, () => {
      // this.getCategory();
      this.getProductList();
    });
    // if (search) {
    //   this.setState({
    //     isSearch: true,
    //     searchValue: search,
    //     searchType: type + ''
    //   }, () => {
    //     this.getCategory();
    //     this.getProductList();
    //   });
    // } else {
    //   this.getCategory();
    //   this.getProductList();
    // }
  }
  getCategory = () => {
    return send({
      url: '/ipp/product/category',
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data.data;
        const categoryList = data.list.reverse() || [];
        // const tree = [];
        // list.forEach((item) => {
        //   let category = {
        //     id: item.id,
        //     name: item.name,
        //     children: [],
        //   };
        //   item.child &&
        //     item.child.forEach((subItem) => {
        //       category.children.push({
        //         id: subItem.id,
        //         name: subItem.name,
        //       });
        //     });
        //   tree.push(category);
        // });
        this.setState({ categoryList });
      }
    });
  };
  getProductList = () => {
    const {
      currentPage,
      checkedCategoryId,
      checkedSubCategoryId,
      searchValue,
      pageSize,
      searchType
    } = this.state;
    send({
      url: '/ipp/product/select',
      method: 'POST',
      data: {
        name: searchValue,
        type: searchType,
        sys_cat_id: checkedSubCategoryId,
        sys_cat_pid: checkedCategoryId,
        page: currentPage,
        page_size: pageSize,
      },
      options: { loading: true }
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data.data;
        const { list = [], total = 0 } = data;
        const productList = [];
        list.forEach((product) => {
          productList.push(
            Object.assign(product, {
              id: product.sale_id,
              normsId: product.norms_id,
              name: product.sale_name,
              sellerId: product.supplier_name,
              sellerName: product.supplier_name,
              store: product.stock_cur_num,
              imgUrl: product.sale_head_img || product.sku_head_img || product.spu_head_img,
              title: product.sale_name,
              price: product.sale_price,
              subTitle: `供应商：${product.supplier_name}`,
            })
          );
        });
        this.setState({
          productList,
          productNum: total,
        });
      }
    });
  };
  checkedCategory(id) {
    const { categoryList = [], checkedCategoryId} = this.state;
    if (checkedCategoryId === id) {
      return;
    }
    const subCategoryList = (id && categoryList.find(item => item.id === id)?.child) || [];
    this.setState({
      subCategoryList,
      checkedCategoryId: id,
      checkedSubCategoryId: '',
      thirdCategoryList: [],
      fourthCategoryList: [],
    }, this.getProductList);
  }
  checkedSubCategory = (id) => {
    const { checkedSubCategoryId, subCategoryList } = this.state;
    if (checkedSubCategoryId === id) {
      return;
    }
    const subCategory = (id && subCategoryList.find(item => item.id === id)?.child) || [];
    this.setState(
      {
        checkedSubCategoryId: id,
        thirdCategoryList: subCategory,
        fourthCategoryList: [],
      },
      () => {
        this.getProductList();
      }
    );
  };
  checkedThirdCategory = (id) => {
    const { thirdCategoryList, checkedThirdCategoryId } = this.state;
    if (checkedThirdCategoryId === id) {
      return;
    }
    const list = (id && thirdCategoryList.find(item => item.id === id)?.child) || [];
    this.setState(
      {
        checkedThirdCategoryId: id,
        fourthCategoryList: list
      },
      () => {
        this.getProductList();
      }
    );
  }
  checkedFourthCategory = (id) => {
    const { checkedFourthCategoryId } = this.state;
    if (checkedFourthCategoryId === id) {
      return;
    }
    this.setState(
      {
        checkedFourthCategoryId: id,
      },
      () => {
        this.getProductList();
      }
    );

  }
  toProductDetail = (product) => {
    const { spu_id, org_id, norms_id } = product;
    window.open('/basic/product/detail/' + spu_id + '/' + org_id + '/' + norms_id, '_blank');
  };
  add = (value, product) => {
    this.props.addProduct(product, value);
  }
  planAddProduct = (value, product) => {
    this.props.planListAddProduct(product, value);
  }

  renderFilter() {
    const { categoryList, subCategoryList, checkedCategoryId, checkedSubCategoryId,  isOpen, fourthCategoryList, thirdCategoryList, checkedThirdCategoryId, checkedFourthCategoryId,
      isSubOpen, isFourthOpen, isThirdOpen
    } = this.state;
    const visibleCategories = isOpen ? categoryList : categoryList.slice(0, 10);
    const hasMoreCategories = categoryList?.length > 10;
    const visibleSubCategories = isSubOpen ? subCategoryList : subCategoryList.slice(0, 9);
    const hasSubMoreCategories = subCategoryList?.length > 9;
    const visibleThirdCategories = isThirdOpen ? thirdCategoryList : thirdCategoryList.slice(0, 11);
    const hasThirdMoreCategories = thirdCategoryList?.length > 11;
    const visibleFourthCategories = isFourthOpen ? fourthCategoryList : fourthCategoryList.slice(0, 10);
    const hasFourthMoreCategories = fourthCategoryList?.length > 10;
    return (
      <React.Fragment>
        <div className="category-filter-wrapper">
          <div className="category-filter">
            <div className="category-title">一级分类：</div>
            <div className="category-list">
              <span
                onClick={() => {
                  this.checkedCategory('');
                }}
                className={classnames({
                  'category-item': true,
                  active: checkedCategoryId === '',
                })}
              >
                全部
              </span>
              {visibleCategories.map((item) => {
                return (
                  <span
                    key={item.id}
                    onClick={() => {
                      this.checkedCategory(item.id);
                    }}
                    className={classnames({
                      'category-item': true,
                      active: checkedCategoryId === item.id,
                    })}
                  >
                    {item.name}
                  </span>
                );
              })}
              {hasMoreCategories && (
                <Button onClick={() => this.setState({ isOpen: !this.state.isOpen })} className={classnames({
                  'category-item': true,
                  active: true,
                })}>{this.state.isOpen ? '收起' : '展开'}</Button>
              )}
            </div>
          </div>
          {subCategoryList?.length ? (
            <div className="category-filter">
              <div className="category-title">二级分类：</div>
              <div className="category-list">
                <span
                  onClick={() => {
                    this.checkedSubCategory('');
                  }}
                  className={classnames({
                    'category-item': true,
                    active: checkedSubCategoryId === '',
                  })}
                >
                  全部
                </span>
                {visibleSubCategories?.map((item) => {
                  return (
                    <span
                      key={item.id}
                      onClick={() => {
                        this.checkedSubCategory(item.id);
                      }}
                      className={classnames({
                        'category-item': true,
                        active: checkedSubCategoryId === item.id,
                      })}
                    >
                      {item.name}
                    </span>
                  );
                })}
                {hasSubMoreCategories && (
                  <Button onClick={() => this.setState({ isSubOpen: !isSubOpen })} className={classnames({
                    'category-item': true,
                    active: true,
                  })}>{isSubOpen ? '收起' : '展开'}</Button>
                )}
              </div>
            </div>
          ) : null}
          {thirdCategoryList?.length ? (
            <div className="category-filter">
              <div className="category-title">三级分类：</div>
              <div className="category-list">
                <span
                  onClick={() => {
                    this.checkedThirdCategory('');
                  }}
                  className={classnames({
                    'category-item': true,
                    active: checkedThirdCategoryId === '',
                  })}
                >
                  全部
                </span>
                {visibleThirdCategories?.map((item) => {
                  return (
                    <span
                      key={item.id}
                      onClick={() => {
                        this.checkedThirdCategory(item.id);
                      }}
                      className={classnames({
                        'category-item': true,
                        active: checkedThirdCategoryId === item.id,
                      })}
                    >
                      {item.name}
                    </span>
                  );
                })}
                {hasThirdMoreCategories && (
                  <Button onClick={() => this.setState({ isThirdOpen: !isThirdOpen })} className={classnames({
                    'category-item': true,
                    active: true,
                  })}>{isThirdOpen ? '收起' : '展开'}</Button>
                )}
              </div>
            </div>
          ) : null}
          {fourthCategoryList?.length ? (
            <div className="category-filter">
              <div className="category-title">四级分类：</div>
              <div className="category-list">
                <span
                  onClick={() => {
                    this.checkedFourthCategory('');
                  }}
                  className={classnames({
                    'category-item': true,
                    active: checkedFourthCategoryId === '',
                  })}
                >
                  全部
                </span>
                {visibleFourthCategories?.map((item) => {
                  return (
                    <span
                      key={item.id}
                      onClick={() => {
                        this.checkedFourthCategory(item.id);
                      }}
                      className={classnames({
                        'category-item': true,
                        active: checkedFourthCategoryId === item.id,
                      })}
                    >
                      {item.name}
                    </span>
                  );
                })}
                {hasFourthMoreCategories && (
                  <Button onClick={() => this.setState({ isFourthOpen: !isFourthOpen })} className={classnames({
                    'category-item': true,
                    active: true,
                  })}>{isFourthOpen ? '收起' : '展开'}</Button>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  renderProduct = (productList) => {
    const rowLen = Math.ceil(productList.length / 5);
    const rows = [];
    for (let i = 0; i < rowLen; i++) {
      const temp = { children: [] };
      rows.push(temp);
      for (let j = 0, colLen = 5; j < colLen; j++) {
        productList[i * 5 + j] && temp.children.push(productList[i * 5 + j]);
      }
    }
    return (
      <React.Fragment>
        {rows.map((row, index) => {
          return (
            <div key={index} className="product-row-container">
              {row.children.map((product, subIndex) => {
                return (
                  <ProductCart
                    key={product.id}
                    end={subIndex === 4}
                    addProduct={(value) => {
                      this.add(value, product);
                    }}
                    planListAddProduct={(value) => {
                      this.planAddProduct(value, product);
                    }}
                    toProductDetail={() => {
                      this.toProductDetail(product);
                    }}
                    reFresh={() => {
                      this.getProductList();
                    }}
                    transferOrder={(id, orderNo) => { this.transferOrder(id, orderNo); }}
                    {...product}
                    stock={`${+product.stock_cur_num}${product.unit}`}
                  />
                );
              })}
            </div>
          );
        })}
      </React.Fragment>
    );
  };
  reset = () => {
    this.props.history.push('/basic/index');
    // this.setState({ isSearch: false, searchValue: '', searchType: '1', checkedCategoryId: '', checkedSubCategoryId: '', categoryList: [], subCategoryList: [], productList: [], currentPage: 1, pageSize: 50, productNum: 0, }, () => {
    //   this.getCategory();
    //   this.getProductList();
    // }
    // );
  };
  searchTypeChanged = (value) => {
    this.setState({
      searchType: value
    });
  }
  searchValueChanged = (value) => {
    this.setState({
      searchValue: value
    });
  }
  searchProduct = () => {
    this.setState({
      isSearch: true,
      checkedCategoryId: '',
      checkedSubCategoryId: '',
      currentPage: 1
    }, () => {
      this.getProductList();
    });
  }
  transferOrder = (id, orderNo) => {
    // console.log('预订转订单');
    this.props.history.push(`/basic/transfer/order?${queryString({ id, orderId: orderNo })}`);
  }

  render() {
    const { currentPage, pageSize, productNum, searchValue, searchType, isSearch } = this.state;
    const { productList } = this.state;
    return (
      <div className="home">
        <div className="home-header">
          <div className="logo" onClick={this.reset}></div>
          <div className="search">
            <CpSearchBar
              searchValue={searchValue}
              searchType={searchType}
              searchValueChanged={this.searchValueChanged}
              searchTypeChanged={this.searchTypeChanged}
              searchProduct={this.searchProduct} />
          </div>
        </div>
        {this.renderFilter()}
        <div className="product-container">
          {this.renderProduct(productList)}
        </div>
        {
          isSearch && searchValue && (!productList || !productList.length) ? (
            <div className="empty">
              <span className="empty-tip">没有找到与“<span style={{ color: '#D60505' }}>{searchValue}</span>”相关的商品，看看其他吧~</span>
            </div>
          ) : null
        }
        <div className="home-footer" hidden={productNum <= 0}>
          <Pagination
            total={productNum}
            pageSize={pageSize}
            current={currentPage}
            onChange={(page, pageSize) => {
              this.setState(
                {
                  currentPage: page,
                  pageSize
                },
                () => {
                  this.getProductList();
                }
              );
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productsInCart: state.shopCart.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addProduct: (product, value) => {
      dispatch(addProduct(product, value));
    },
    planListAddProduct: (product, value) => {
      dispatch(planListAddProduct(product, value));
    },
    reduceProduct: (productId) => {
      dispatch(reduceProduct(productId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);